// src/pages/HomeLayout.jsx
import React from "react";
import NavBar from "../components/NavBar";
import { Outlet } from "react-router-dom";

const HomeLayout = () => {
  return (
    <>
      <NavBar />
      <div className="">
        <Outlet />
      </div>
    </>
  );
};

export default HomeLayout;